// extracted by mini-css-extract-plugin
export default {"searchSuffix":"Search_searchSuffix__PwUu+"};